/*=========================================================================================
  File Name: moduleCalendarActions.js
  Description: Calendar Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"
import http from "axios"

export default {
  getAllUserList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user_management")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_ALL_USER_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getActiveUserList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user_manage")
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_ACTIVE_USER_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAdminInsight({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/admin_dashboard")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_INSIGHT_INFO', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 대시보드 문제 검토 현황 카드 클릭 시 펼치는 상세 목록 (waiting/in_progress/done_today/stale)
  getReviewList(context, category) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/admin_dashboard/review_list", {
        params: { category }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list || [])
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getShortageSummary({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/question-pool/shortage")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_SHORTAGE_SUMMARY', response.data.by_type || [])
            commit('SET_SHORTAGE_FOCUS_PERIOD', response.data.focus_period || null)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getEnterInsight({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user_dashboard")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_ENTER_INFO', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getClassInsight({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/teacher_dashboard")
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_CLASS_INFO', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setUserLevel(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user/level", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setUserSubject({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user/class_type", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_USER_SUBJECT', response.data.data_list)
            console.log(response)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  sendUserCaution({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/common/user/warning", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            commit('SET_CAUTION_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  withdrawalUser(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user/out/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUserDetail({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user_management_detail?user_id=" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_USER_DETAIL', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUserWarningDetail(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user/get_warning?user_id="+ payload)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 검토 모니터링(관리자): 여러 유저의 정산 건수(=완료 처리 건수)를 한 번에 조회
  getAccountCountByUsers(context, userIds) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/account_count_by_users", {
        params: { user_ids: userIds.join(',') }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 정산 관리(관리자): 월별 정산 요약 목록
  getMonthlySettlement(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/settlement/monthly", {
        params: { year: payload.year, month: payload.month }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 정산 관리(관리자): 특정 사용자의 해당 월 상세 내역
  getSettlementUserDetail(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/settlement/user_detail", {
        params: { user_id: payload.user_id, year: payload.year, month: payload.month }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 정산 관리(관리자): 조정 추가 대상 사용자 검색 (레벨4미만)
  searchSettlementUsers(context, search) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/settlement/users", {
        params: { search: search || '' }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data_list)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 정산 관리(관리자): 정산금 추가/차감 (amount 음수=차감)
  adjustSettlement(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/admin/settlement/adjust", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 정산 관리(관리자): 월별 정산 엑셀 다운로드
  exportSettlement(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/settlement/export", {
        params: { year: payload.year, month: payload.month },
        responseType: 'blob'
      }).then((response) => {
        resolve(response)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 정산 관리(관리자): 해당 월의 정산 기간(마감일 override 포함) 조회
  getSettlementPeriod(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/admin/settlement/period", {
        params: { year: payload.year, month: payload.month }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response.data.data)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  // 정산 관리(관리자): 해당 월의 마감일 override 설정
  setSettlementPeriod(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/admin/settlement/period", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          } else {
            reject(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  // 정산 관리(관리자): 해당 월의 마감일 override 삭제 (기본값으로 복귀)
  resetSettlementPeriod(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/admin/settlement/period", {
        params: { year: payload.year, month: payload.month }
      }).then((response) => {
        if (response.data.result == 'success') {
          resolve(response)
        } else {
          reject(response)
        }
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getUserAccountList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/account_user?user_id=" + payload.id + "&start_date=" + payload.start_date + '&end_date=' + payload.end_date)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_ACCOUNT_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getHoliday({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      http.get("http://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/" + payload.operation + '?solMonth=' + payload.params.solMonth + '&solYear=' + payload.params.solYear + '&serviceKey=' + payload.serviceKey)
        .then((res) => {
          console.log(res)
          if (res.data.response.header.resultCode == '00') {
            commit('SET_HOLIDAY_LIST', res.data)
            resolve(res)
          }
          reject(res)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getAlarmList({
    commit
  }) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/user/alarm")
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_ALARM_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  changeUserAlarmState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user/alarm", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  changeAlarmState(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user_alarm", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setUserNote(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user/detail", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  saveUserWorkTime(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/user/work_day", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  setUserEvent(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/v2/common/admin_calendar", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getEvent({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      // axios.get("/api/v2/common/admin_calendar?year="+ payload.year + "&month=" + payload.month)
      axios.get("/api/v2/common/admin_calendar?year="+ payload.year + "&month=" + payload.month + "&user_id=" + payload.user_id)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_EVENT_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getUserWorkHours({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      // axios.get("/api/v2/common/admin_calendar?year="+ payload.year + "&month=" + payload.month)
      axios.get("/api/v2/common/calendar/user_work_time?user_id=" + payload.user_id + "&date=" + payload.date)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_USER_WORK_HOURS', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  getDoneList({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      // axios.get("/api/v2/common/admin_calendar?year="+ payload.year + "&month=" + payload.month)
      axios.get("/api/v2/common/user_management_detail/finish_list?user_id=" + payload.user_id + "&date=" + payload.date)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_USER_DONE_LIST', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  
  getUserWorkTime({
    commit
  }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/v2/common/admin_calendar?year="+ payload.year +"&month=" + payload.month)
        .then((response) => {
          if (response.data.result == 'success') {
            console.log(response)
            commit('SET_USER_WORK_TIME', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  changeEvent(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/common/admin_calendar", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  deleteEvent(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/v2/common/admin_calendar/" + payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  regenerateSolveText(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/question/solve_text_regenerate", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  generateOriginalSolveText(context, payload) {
    return new Promise((resolve, reject) => {
      axios.put("/api/v2/exam/question/original_solve_text_generate", payload)
        .then((response) => {
          if (response.data.result == 'success') {
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}
